import { render, staticRenderFns } from "./KYC.vue?vue&type=template&id=68f6e52c&scoped=true&"
import script from "./KYC.vue?vue&type=script&lang=js&"
export * from "./KYC.vue?vue&type=script&lang=js&"
import style0 from "./KYC.vue?vue&type=style&index=0&id=68f6e52c&prod&lang=css&"
import style1 from "./KYC.vue?vue&type=style&index=1&id=68f6e52c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f6e52c",
  null
  
)

export default component.exports